import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "First name",
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "Last name",
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "Email address",
                inputType: "email",
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "Phone number",
                required: false,
                inputType: "phone",
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "Company/Organization",
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What days do you plan on attending the event?",
                choices: [
                    generateNewChoice("Date 1"),
                    generateNewChoice("Date 2"),
                    generateNewChoice("Date 3"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceMulti"],
                headline:
                    "Do you follow any of the these dietary restrictions? (Please select all that apply.)",
                choices: [
                    generateNewChoice("Vegan"),
                    generateNewChoice("Vegetarian"),
                    generateNewChoice(
                        "Religious Dietary Restrictions (e.g., Kosher, Halal)"
                    ),
                    generateNewChoice("Lactose Free"),
                    generateNewChoice(
                        "Weight Loss Diet (e.g. Keto, Low Sugar, Weight Watchers)"
                    ),
                    generateNewChoice("Low Salt"),
                    generateNewChoice(
                        "Food Allergy (e.g. gluten free, peanut free)"
                    ),
                    generateNewChoice("Intermittent Fasting"),
                    generateNewChoice(
                        "I do not follow any of these dietary restrictions"
                    ),
                    generateNewChoice("Prefer not to answer"),
                    generateNewChoice("Other"),
                ],
            },
        ],
    },
];

export const eventRegistrationFormSurveyTemplate = generateSurveyTemplate({
    name: "Event Registration Form Survey",
    pages,
});
